export enum ProductListDataStatus {
  Missing = "Missing data",
  Pending = "Pending approval",
}
